import React, { useState, useEffect } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';

import Navbar from './Navbar';
import Sidebar from './Sidebar';

interface MainLayoutProps {
  children: React.ReactNode;
}

const SIDEBAR_WIDTH = 280;

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  
  // Состояние сайдбара - на мобильных закрыт по умолчанию, на десктопе открыт
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);

  // Обновляем состояние сайдбара при изменении размера экрана
  useEffect(() => {
    setSidebarOpen(!isMobile);
  }, [isMobile]);

  const handleSidebarToggle = () => {
    setSidebarOpen(!sidebarOpen);
  };

  const handleSidebarClose = () => {
    setSidebarOpen(false);
  };

  return (
    <Box sx={{ 
      display: 'flex', 
      minHeight: '100vh',
      overflow: 'hidden' // Убираем скролл на корневом уровне layout
    }}>
      {/* Навигационная панель */}
      <Navbar 
        onMenuToggle={handleSidebarToggle}
        sidebarOpen={sidebarOpen}
      />

      {/* Боковое меню */}
      <Sidebar
        open={sidebarOpen}
        width={SIDEBAR_WIDTH}
        onClose={handleSidebarClose}
      />

      {/* Основное содержимое */}
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          width: {
            xs: '100%',
            md: sidebarOpen ? `calc(100% - ${SIDEBAR_WIDTH}px)` : '100%',
          },
          height: '100vh', // Фиксированная высота экрана
          backgroundColor: 'background.default',
          overflow: 'auto', // Включаем скролл для main контента
          transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
          }),
        }}
      >
        {/* Отступ для Toolbar */}
        <Box sx={{ height: theme.mixins.toolbar.minHeight }} />
        
        {/* Контент страницы с отступами */}
        <Box
          sx={{
            p: 3,
            pt: 2,
            width: '100%',
          }}
        >
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default MainLayout; 
 
 
 